import React from "react";
import { ContactCard, ContactSection } from "@/.storyblok/types/319751/storyblok-components";
import { renderRichText } from "@/lib/richText";
import Image from "next/image";
import Link from "next/link";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface ContactSectionProps {
  blok?: ContactSection & SbBlokData & {
    contact_cards?: ContactCard[];
  };
}

const ContactSectionComponent: React.FC<ContactSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, description, contact_cards, footer_text } = blok;

  const renderContactCard = (card: ContactCard) => {
    const { icon, title, content_type, value, _uid } = card;

    const renderContent = () => {
      switch (content_type) {
        case "phone":
          return (
            <p className="mb-0">
              <Link
                href={`tel:${value}`}
                style={{ textDecoration: "underline" }}
              >
                {value}
              </Link>
            </p>
          );
        case "email":
          return (
            <p className="mb-0">
              <Link
                href={`mailto:${value}`}
                style={{ textDecoration: "underline" }}
              >
                {value}
              </Link>
            </p>
          );
        case "address":
        case "reg_address":
          return (
            <p className="mb-0">
              {value}
            </p>
          );
        default:
          return null;
      }
    };

    return (
      <div className="col text-center" key={_uid}>
        {icon?.filename && (
          <Image
            src={icon.filename}
            alt={icon.alt || title || ""}
            width={70}
            height={70}
            className="mb-3"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        {title && <h4 className="mb-2">{title}</h4>}
        {renderContent()}
      </div>
    );
  };

  return (
    <div {...storyblokEditable(blok)} className="container py-4 py-md-5">
      {title && <h2 className="text-center">{title}</h2>}
      {description && <p className="text-center mb-4">{description}</p>}
      {contact_cards && contact_cards.length > 0 && (
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 gy-4 gy-md-0 text-center mb-4">
          {contact_cards.map(renderContactCard)}
        </div>
      )}
      {footer_text && (
        <div
          className="text-center mb-4"
          dangerouslySetInnerHTML={{ __html: renderRichText(footer_text) }}
        />
      )}
    </div>
  );
};

export default ContactSectionComponent;